export default "__VITE_PUBLIC_ASSET__bf06d346__"